import React, { Component, useState, Fragment } from "react";
import settings from '../settings.json';
import './../App.css';
import InputGroup from 'react-bootstrap/InputGroup';
import { Modal, Button, Form } from "react-bootstrap";


export default class hello extends Component{
  componentDidMount () {
    var url = settings.API_ENDPOINT_URL;

    const getDBData = async () => {
      //https://api.hello-remix.com/users?limit=3
      const res = await fetch(
        url + '/users/?limit=3'
      );
      const data = await res.json();
      console.dir(data);

    };

    getDBData();
  }


  render(){
    return (
      <div className="App">
        
        <InputGroup size="sm" className="border border-warning">
          <Form.Control 
						type="date" 
						name="from" 
						placeholder="" 
						aria-describedby="from" 
						//id={"tonya_syukka_date_"+String(row.id)} 
						//data-index={index} 
						//value={row.check_date} 
						//onChange={event=>handleInputChange(event)} 
					/>
        </InputGroup>
      </div>
    );
  }
}

